const activeClass = 'active';

const toggleModal = (modal, e) => {
  const body = document.querySelector('body');
  if (e) {
    e.preventDefault();
  }
  body.toggleAttribute('data-noscroll');
  modal.classList.toggle(activeClass);
};

const initCloseModal = (modal) => {
  const close = modal.querySelectorAll('.modal-close');
  [...close].forEach(elm => elm.addEventListener('click', e => toggleModal(modal, e)));
  modal.addEventListener('click', (e) => {
    const target = e.target;
    if (!target.classList.contains('modal-body') && !target.closest('.modal-body')) {
      toggleModal(modal, e);
    }
  });
};

export function initModal(targetEl) {
  const target = targetEl || document;
  target.querySelectorAll('[data-modal]').forEach((trigger) => {
    const id = trigger.dataset.modal;
    const modal = target.querySelector(`#${id}`);
    const toggle = (e) => {
      toggleModal(modal, e);
    };
    trigger.addEventListener('click', toggle);
    initCloseModal(modal);
  });
}
